"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intlI18n = require("@/i18n/intl-i18n");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CategoryFilter',
  mixins: [_intlI18n.intlMixin],
  props: {
    categories: {
      type: Array,
      required: true
    },
    active: {
      type: String,
      default: 'all'
    }
  },
  methods: {
    // 分类属于业务数据，名称一律使用后端动态翻译
    labelOf: function labelOf(cat) {
      if (cat.key === 'all') return this.$t('categories.all');
      return cat.translations && cat.translations[this.$intlLang] || '';
    }
  }
};